/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import { Box, createTheme } from '@mui/system';
import { Typography } from '@mui/material';
import BtnComponent from '../buttonComponent/BtnComponent';
import { useTimer } from '../../shared/useTimer';
import {
  PHONE_VERIFICATION_SUCCESS_TEXTS,
  PHONE_VERIFICATION_TEXTS,
} from '../../shared/constants';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  GENERATE_OTP,
  VALIDATE_OTP,
} from '../../services/userQueries/userService';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../SimpleBackdropComponent/SimpleBackdrop';
import { TimerComponent } from './TimerComponent';
import EditPhoneNumber from './EditPhoneNumber';
import SuccessBox from '../SuccessBox/SuccessBox';
import { getUSFormatPhoneNo } from '../../shared/helper';
import { ERROR_MSGS, OTP_VERIFICATION } from '../../shared/Strings';

const otparray = {
  textAlign: 'center',
  border: '1px solid #CCCCCC',
  width: '100%',
  maxWidth: '72px',
  fontWeight: 600,
  fontSize: '28px',
  minHeight: '72px',
  borderRadius: '4px',
  marginRight: '12px',
};
const textWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  mt: '12px',
};
const otpFiledWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexDirection: 'row',
  mt: '32px',
};
const iconHover = { '&:hover': { bgcolor: 'transparent', cursor: 'pointer' } };

const OtpVerificationComponent = props => {
  const theme = createTheme();
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [popupChangePhoneNo, setPopupChangePhoneNo] = useState(false);
  const newPhoneNo = '';
  const [verificationSid, setVerificationSid] = useState(null);
  const [validateOTPDisabled, setValidateOTPDisabled] = useState(true);
  const phoneNoError = false;
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber);
  const [updatePhoneInDB, setUpdatePhoneInDB] = useState(false);

  const [resendOTP, resendOTPCall] = useLazyQuery(GENERATE_OTP, {
    fetchPolicy: 'cache-and-network',
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_REGENERATING_OTP, {
        variant: 'error',
      });
      setResendTime(0);
    },
    onCompleted: res => {
      setVerificationSid(res.generateOTPUnAuthMember.verificationSid);
      enqueueSnackbar(OTP_VERIFICATION.OTP_RESEND_SUCCESS, {
        variant: 'success',
      });
      setResendTime(59);
    },
  });

  const [validateOTP, validateOTPCall] = useMutation(VALIDATE_OTP, {
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_VALIDATING_OTP, {
        variant: 'error',
      });
    },
  });

  const [resendTime, setResendTime] = useTimer({
    startTime: 59,
    multiplier: 1,
    direction: 'down',
    endTime: 0,
    timeOut: 1000,
  });
  const { enqueueSnackbar } = useSnackbar();

  const generateOTP = useQuery(GENERATE_OTP, {
    fetchPolicy: 'no-cache',
    variables: { phone: props?.phoneNumber },
    onError: err => {
      enqueueSnackbar(ERROR_MSGS.WENT_WRONG_GENERATING_OTP, {
        variant: 'error',
      });
      setResendTime(0);
    },
  });

  const handlePopupChangePhoneNo = () => {
    setPopupChangePhoneNo(true);
  };

  const handleNewPhoneNo = element => {
    setPhoneNumber(element);
    setUpdatePhoneInDB(true);
    resendOTP({ variables: { phone: element } });
  };
  const handleChange = (element, index) => {
    if (isNaN(element.value)) {
      return false;
    }
    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Array size is fixed to 4 so we cannot find the exact length of array after changing the values so we are converting the array into string.
    const otpString = [
      ...otp.map((d, idx) => (idx === index ? element.value : d)),
    ].toString();
    const otpStringLength = otpString.length;

    //we are having an array of length 4 and when we convert the array into string so 3 commas are already there for sepating the values and 4 values from boxes so that altogether length of that string should be 7.
    if (otpStringLength === 7) setValidateOTPDisabled(false);
    else setValidateOTPDisabled(true);

    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    }
    if (!element.value) {
      element.previousSibling.focus();
    }
    // else if (element.keyCode === 8) {
    //   // element.previousSibling.focus();
    //   // element.target.value = '';
    //   console.log('hi');
    //   // element.previousSibling.select();
    // }
  };

  const handleRedirection = () => {
    const otpValue = otp.join('');
    validateOTP({
      variables: {
        validateOTPRequest: {
          verificationSid: verificationSid,
          otp: otpValue,
          phoneNumber: phoneNumber,
          updateDatabase: updatePhoneInDB,
        },
        userId: props.userId,
      },
    });
  };
  const numberValidation = phoneno => {
    // const intMobileNo = getUSFormatPhoneNo(phoneno);
    // const { isValid, errorMessage } = validatePhone(intMobileNo);
    // if (!isValid) {
    //   return false;
    // }
    return true;
  };

  // const phonenumberValue = e => {
  //   const { name, value } = e.target;
  //   if (name === 'phonenumber') {
  //     setAccountFormValues({
  //       ...accountFormValues,
  //       [name]: getUSFormatPhoneNo(value),
  //     });
  //   } else {
  //     setAccountFormValues({ ...accountFormValues, [name]: value });
  //   }
  // };

  // eslint-disable-next-line no-unused-vars
  const handleSaveChanges = () => {
    if (numberValidation(newPhoneNo)) {
      setPhoneNumber(newPhoneNo);
      setUpdatePhoneInDB(true);
      handlePopupChangePhoneNo();
      resendOTP({ variables: { phone: newPhoneNo } });
    }
  };
  useEffect(() => {}, []);
  const handleClearotp = e => {
    setOtp([...otp.map(v => '')]);
  };

  const handleResend = () => {
    resendOTP({ variables: { phone: phoneNumber } });
  };

  useEffect(() => {
    if (generateOTP?.data?.generateOTPUnAuthMember) {
      setVerificationSid(
        generateOTP.data.generateOTPUnAuthMember.verificationSid
      );
      enqueueSnackbar(OTP_VERIFICATION.OTP_SEND_SUCCESS, {
        variant: 'success',
      });
      setResendTime(59);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generateOTP?.data?.generateOTPUnAuthMember]);

  useEffect(() => {
    if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.PENDING
    ) {
      enqueueSnackbar(ERROR_MSGS.WRONG_OTP, {
        variant: 'error',
      });
      handleClearotp();
    } else if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.EXPIRED
    ) {
      enqueueSnackbar(ERROR_MSGS.OTP_EXPIRED, {
        variant: 'error',
      });
      setResendTime(0);
    } else if (
      validateOTPCall?.data?.validateOTPUnAuthMember
        ?.phoneVerificationStatus ===
      PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.APPROVED
    ) {
      window.history.replaceState(null, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOTPCall?.data?.validateOTPUnAuthMember]);

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!(
          validateOTPCall?.data?.validateOTPUnAuthMember
            ?.phoneVerificationStatus ===
          PHONE_VERIFICATION_SUCCESS_TEXTS.PHONE_VERIFICATION_STATUS.APPROVED
        ) ? (
          <>
            <Typography sx={{ mt: 6 }} variant="title">
              {PHONE_VERIFICATION_TEXTS.TITLE}
            </Typography>
            <Box sx={textWrapper}>
              <Typography sx={{ color: '#666666', mr: 1 }}>
                {PHONE_VERIFICATION_TEXTS.BODY}
              </Typography>
              <Box sx={{ mr: 1, color: '#00A0DF', fontWeight: 600 }}>
                {getUSFormatPhoneNo(phoneNumber)}
              </Box>
              <EditIcon
                color="#000000"
                sx={iconHover}
                size="small"
                onClick={handlePopupChangePhoneNo}></EditIcon>
              <EditPhoneNumber
                popupChangePhoneNo={popupChangePhoneNo}
                setPopupChangePhoneNo={setPopupChangePhoneNo}
                handleSaveChanges={handleNewPhoneNo}
                phoneNoError={phoneNoError}
                value={phoneNumber}
                existingPhoneNumber={props.phoneNumber}
              />
            </Box>
            <Box sx={otpFiledWrapper}>
              {otp.map((data, index) => {
                return (
                  <input
                    style={otparray}
                    type="text"
                    name="otp"
                    maxLength="1"
                    key={index}
                    value={data}
                    onChange={e => handleChange(e.target, index)}
                    onFocus={e => e.target.select()}
                  />
                );
              })}
            </Box>
            <Typography
              sx={{
                mt: '40px',
                color: '#000000',
              }}>
              {PHONE_VERIFICATION_TEXTS.NO_RECEIVE}
            </Typography>
            {resendTime !== 0 ? (
              <TimerComponent resendTime={resendTime} />
            ) : (
              <Box
                sx={{
                  '&:hover': { bgcolor: 'transparent', cursor: 'pointer' },
                  color: '#0060BA',
                  fontWeight: 'normal',
                  fontSize: '14px',
                  lineHeight: '20px',
                  mt: '11px',
                }}>
                <a type="button" onClick={handleResend}>
                  {PHONE_VERIFICATION_TEXTS.OPT_RESENT}
                </a>
              </Box>
            )}
            <Box sx={{ mt: '32px' }}>
              <BtnComponent
                sx={{ p: '8px 40px', mr: '18px' }}
                size="large"
                onClick={handleRedirection}
                title="Verify"
                disabled={validateOTPDisabled}
              />
            </Box>
          </>
        ) : (
          <SuccessBox text={PHONE_VERIFICATION_TEXTS.VERIFY_OTP_TEXT} />
        )}
        <SimpleBackdrop
          open={
            resendOTPCall?.loading ||
            validateOTPCall?.loading ||
            generateOTP?.loading
          }
        />
      </Box>
    </ThemeProvider>
  );
};

export default OtpVerificationComponent;
